if (!customElements.get("product-form-bundle")) {
  customElements.define(
    "product-form-bundle",
    class ProductFormBundle extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        $(".error-msg-bundle").remove();
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        if (window.matchMedia("(min-width: 768px)").matches) {
          var totalcount = 0;

          $(".desktop-view .product-bundle-product-checkbox:checked").each(
            function (index) {
              totalcount =
                totalcount +
                Number($(this).parent().find(".custom-product-input").val());
            }
          );
           
          if ($('input[name="product-tab-size"]:checked').val() == "3-PACK") {
            if (totalcount >= 3) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 3 items.</div>'
                );
              return;
            }
          }
          if ($('input[name="product-tab-size"]:checked').val() == "4-PACK") {
            if (totalcount >= 4) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 4 items.</div>'
                );
              return;
            }
          }
          if ($('input[name="product-tab-size"]:checked').val() == "6-PACK") {
            if (totalcount >= 6) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 6 items.</div>'
                );
              return;
            }
          }
        } else {
          var totalcount = 0;

          $(".mobile-view .product-bundle-product-checkbox:checked").each(
            function (index) {
              totalcount =
                totalcount +
                Number($(this).parent().find(".custom-product-input").val());
            }
          );
          if ($('input[name="product-tab-size"]:checked').val() == "3-PACK") {
            if (totalcount >= 3) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 3 items.</div>'
                );
              return;
            }
          }
          if ($('input[name="product-tab-size"]:checked').val() == "4-PACK") {
            if (totalcount >= 4) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 4 items.</div>'
                );
              return;
            }
          }
          if ($('input[name="product-tab-size"]:checked').val() == "6-PACK") {
            if (totalcount >= 6) {
            } else {
              $('.orginal-product-form[data-packsize="all"]')
                .find(".product-form__buttons")
                .after(
                  '<div class="error-msg-bundle">Please select at least 6 items.</div>'
                );
              return;
            }
          }
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        // Prepare cart items array for Shopify Cart API
        var bundleid = Math.floor(Math.random() * 10000000000 + 1);
        var cartItems = [];
        var selectedpack = $(this)
          .parents(".orginal-product-form")
          .find('fieldset[data-optionname="Packaging"]')
          .find("input:checked")
          .val();
        var selectedPurchaseOption = $(this)
          .parents(".orginal-product-form")
          .find('input[name="purchaseOption"]:checked')
          .val();
        var selectedSellingPlan = $(this)
          .parents(".orginal-product-form")
          .find('input[name="selling_plan"]:checked')
          .val();
        var selectedSellingPlanName = $(this)
          .parents(".orginal-product-form")
          .find('input[name="selling_plan"]:checked')
          .attr('data-sellingname');

        // Get the selected products based on device type
        var selectedProducts = window.matchMedia("(min-width: 768px)").matches
          ? $(".desktop-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox:checked")
          : $(".mobile-view .custom-products-container-main .custom-products-wrapper .product-bundle-product-checkbox:checked");
        
        console.log("Found selected products:", selectedProducts.length);
        
        // Build the product items array
        selectedProducts.each(function() {
          var productWrapper = $(this).closest('.custom-products-wrapper');
          
          // Check which packaging option is selected
          var selectedPackaging = selectedpack && selectedpack.includes('Jars') ? 'jars' : 'bags';
          
          // Use the appropriate variant ID based on packaging type
          var variantId = $(this).attr(`data-varid-${selectedPackaging}`);
          
          // Fallback to default variant ID if specific packaging variant not available
          if (!variantId) {
            variantId = $(this).attr("data-varid");
          }
          
          // Fallback to checkbox value if no variant ID is available
          if (!variantId) {
            variantId = $(this).val();
          }
          
          var quantity = Number(productWrapper.find(".custom-product-input").val()) || 1;
          
          console.log("Processing product for cart:", variantId, "quantity:", quantity, "packaging:", selectedPackaging);
          
          if (variantId && variantId !== "undefined" && quantity > 0) {
            var itemObj = {
              id: Number(variantId),
              quantity: quantity,
              properties: {
                _bundle_name: bundleid
              }
            };
            
            // Add selling plan if subscription is selected
            if (selectedPurchaseOption == 'subscription') {
              var orgpr = productWrapper.find('.op-inner');
              if (orgpr.length) {
                var sellingPlanId = orgpr.find('.op-inner-sellingplan[data-sellingplanname="'+selectedSellingPlanName+'"]').attr('data-sellingplanid');
                if (sellingPlanId) {
                  itemObj.selling_plan = sellingPlanId;
                }
              }
            }
            
            cartItems.push(itemObj);
          }
        });
        
        // Add the bundle product itself
        var bundleElement = $(this).find('input[name="id"]')[0];
        var bundleId = $(this).find('input[name="id"]').val();
        var selectedPackagingVariant = selectedpack.includes('Jars') ? 'jars' : 'bags';

        if (selectedPackagingVariant === 'bags' && bundleElement.dataset.bagsId) {
          bundleId = bundleElement.dataset.bagsId;
        } else if (selectedPackagingVariant === 'jars' && bundleElement.dataset.jarsId) {
          bundleId = bundleElement.dataset.jarsId;
        }

        console.log({bundleElement})
        if (bundleId && bundleId !== "undefined") {
          var bundleObj = {
            id: Number(bundleId),
            quantity: 1,
            properties: {
              _bundle: true,
              _bundle_id: bundleid
            }
          };
          
          if (selectedPurchaseOption == 'subscription' && selectedSellingPlan) {
            bundleObj.selling_plan = selectedSellingPlan;
          }
          
          cartItems.push(bundleObj);
        }
        
        // Check if we have items to add
        if (cartItems.length === 0) {
          this.handleErrorMessage("No valid products selected");
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading__spinner").classList.add("hidden");
          return;
        }
        
        // Prepare the sections for cart update
        var sections = [];
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map((section) => section.id);
        }
        
        // Build the request data
        var requestData = {
          items: cartItems
        };
        
        if (sections.length > 0) {
          requestData.sections = sections;
          requestData.sections_url = window.location.pathname;
        }
        
        // Use Shopify Cart API to add items
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(response => {
          if (response.status && response.status !== 200) {
            console.log("Error:", response);
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              errors: response.description || response.message,
              message: response.message,
            });
            this.handleErrorMessage(response.description || response.message);
            
            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (soldOutMessage) {
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
            }
            this.error = true;
            return;
          }
          
          if (!this.cart) {
            window.location = window.Shopify.routes.root + "cart";
            return;
          }
          
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              cartData: response
            });
          }
          
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch(error => {
          console.error("Error:", error);
          this.handleErrorMessage("An error occurred. Please try again.");
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }
          if (!this.error) {
            this.submitButton.removeAttribute("aria-disabled");
          }
          this.querySelector(".loading__spinner").classList.add("hidden");
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}